import React from 'react';

import * as analytics from 'analytics/Analytics';
import {TUTORIAL_ROUTES} from 'constants/TutorialConstants';
import ContinueButton from 'nav/full-screen/ContinueButton';

interface Props {
  headerText: string;
  paragraphText: string;
  onContinue: () => void;
  existingRegistry: boolean;
}

class WebinarScreen extends React.Component<Props> {
  _handleTutorialClick = (): void => {
    analytics.track('registry_activation', 'tutorial', {existing_registry: this.props.existingRegistry});
  };

  _handleWebinarClick = (): void => {
    analytics.track('registry_activation', 'webinar', {existing_registry: this.props.existingRegistry});
  };

  override render(): JSX.Element {
    return (
      <div className="registryActivation-main">
        <div>
          <h1 className="registryActivation-header">{this.props.headerText}</h1>
          <div className="webinarScreen-paragraph registryActivation-container-content">
            <p>{this.props.paragraphText}</p>
            <p>
              To learn more about the Registry, visit our tutorials{' '}
              <a
                href={TUTORIAL_ROUTES.REGISTRY_CREATING_NEW_DATA}
                target="_blank"
                rel="noopener noreferrer"
                onClick={this._handleTutorialClick}
              >
                here
              </a>{' '}
              or watch the recording of our Webinar below!
            </p>
            <div className="webinarScreen-buttons">
              <span className="webinarScreen-sign-up">
                <a
                  className="button button--large button--tertiaryBlue"
                  href="https://www.youtube.com/watch?v=F2XyXv1aaiQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={this._handleWebinarClick}
                >
                  Watch Webinar
                </a>
              </span>
              <span className="webinarScreen-continue-button">
                <ContinueButton
                  text="Start using my Registry"
                  onClick={this.props.onContinue}
                  primary={true}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WebinarScreen;
